var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',{attrs:{"type":"card-full"}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.remindProject}},[_vm._v("竞价提醒")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }